import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const BillingRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

const BillingLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#4A5568',
}));

const BillingValue = styled(Typography)<{ isred?: string }>(({ theme, isred }) => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  color: isred === "true" ? '#E53E3E' : '#1A202C',
}));

const BillingSubscriptions: React.FC = () => {
  const billingData = [
    { label: 'Monthly Invoiced', value: '$8,335,234' },
    { label: 'Subscription Fees', value: '$4,532,237' },
    { label: 'API Usage Fees', value: '$3,802,997' },
    { label: 'Total Collected', value: '$6,251,426' },
    { label: 'Accounts Receivables', value: '$1,667,046' },
    { label: 'Total Past Due', value: '$416,762', isRed: true },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        Billing & Subscriptions
      </Typography>
      {billingData.map((item, index) => (
        <BillingRow key={index}>
          <BillingLabel>{item.label}</BillingLabel>
          <BillingValue isred={item.isRed ? "true" : "false"}>{item.value}</BillingValue>
        </BillingRow>
      ))}
    </Box>
  );
};

export default BillingSubscriptions; 